import {useRouter} from 'next/router';

export const useIsNeedRoute = (path: string) => {
    const {route} = useRouter();

    return Boolean(route.includes(path));
};
